import { ActionCard, Assessment, ElementKind } from '@playbooks/core/src/interfaces/ActionCard'

function makeAssessmentsChecked(ac: ActionCard) {
  ac.sections.forEach(sec => {
    sec.elements?.forEach(el => {
      if (el.kind !== ElementKind.ASSESSMENT) return
      const assessment = el as Assessment

      assessment.checked = assessment.checked ? assessment.checked : assessment.responses?.some(resp => resp.checked)
    })
  })
}

export default makeAssessmentsChecked
